'use strict';
import angular from 'angular';
import './base/export.directives';
import './base/export.services';

angular.module('core.export', [
    'core.export.directives',
    'core.export.services'
]);